import { Text } from '@frameio/vapor';
import TEXT from './generated/TEXT/UploadMarkersRow';
import { SettingRowToggle } from './SettingRowToggle';

TEXT.DEFINE({
  /** Label for uploading markers as comments */
  uploadMarkersAsComments: 'Upload Markers as Comments',
});

export const UploadMarkersRow = ({
  enabled,
  onEnabledChange,
}: {
  /** Whether upload markers is enabled. */
  enabled: boolean;
  /** Called when the toggle state changes. */
  onEnabledChange: (enabled: boolean) => void;
}) => {
  return (
    <SettingRowToggle
      checked={enabled}
      label={
        <Text color="primary" style={{ textWrap: 'nowrap' }} variant="body">
          {TEXT.uploadMarkersAsComments}
        </Text>
      }
      onChange={onEnabledChange}
    />
  );
};
